export default __webpack_public_path__ + "static/media/void_cheque.ebbb9e87.svg";